import React, { useState, useEffect } from "react";

const codeSamples = [
    'const x = [1,2,3].map(n => n*2);',
    'function greet(name){ return `Ciao ${name}` }',
    'let total = prices.reduce((a,b) => a+b, 0);',
    'const fetchData = async () => await fetch("/api");',
];

export default function TypingTest() {
    const [sample, setSample] = useState(codeSamples[Math.floor(Math.random() * codeSamples.length)]);
    const [input, setInput] = useState("");
    const [timeLeft, setTimeLeft] = useState(30);
    const [done, setDone] = useState(false);

    useEffect(() => {
        if (timeLeft > 0 && !done) {
            const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
            return () => clearTimeout(timer);
        } else if (timeLeft === 0) {
            setDone(true);
        }
    }, [timeLeft, done]);

    const accuracy = (() => {
        const correct = sample.split("").filter((ch, i) => ch === input[i]).length;
        return ((correct / sample.length) * 100).toFixed(1);
    })();

    const handleRestart = () => {
        setSample(codeSamples[Math.floor(Math.random() * codeSamples.length)]);
        setInput("");
        setTimeLeft(30);
        setDone(false);
    };

    return (
        <div style={{
            textAlign: "center",
            padding: "1rem",
            color: "#e5e7eb",
            background: "rgba(255,255,255,0.05)",
            borderRadius: "1rem",
            boxShadow: "0 0 25px rgba(0,255,200,0.15)"
        }}>
            <h4 style={{color:"#00ffa3", marginBottom:"0.5rem"}}><i className="fas fa-keyboard"></i> Typing Speed Test</h4>
            <p style={{fontFamily:"monospace", background:"rgba(0,0,0,0.4)", padding:"0.5rem", borderRadius:"0.5rem"}}>
                {sample}
            </p>
            <textarea
                rows="3"
                value={input}
                disabled={done}
                onChange={(e)=>setInput(e.target.value)}
                style={{
                    width:"100%", borderRadius:"0.5rem", background:"rgba(255,255,255,0.1)",
                    color:"#fff", border:"1px solid rgba(255,255,255,0.2)", padding:"0.5rem"
                }}
            />
            <p style={{marginTop:"0.5rem"}}>⏱️ {timeLeft}s — 🎯 Precisione: {accuracy}%</p>
            {done && (
                <button onClick={handleRestart} style={{
                    marginTop:"0.8rem",
                    background:"linear-gradient(135deg,#16a34a,#065f46)",
                    border:"none", color:"#fff", padding:"0.6rem 1.2rem",
                    borderRadius:"0.5rem", cursor:"pointer"
                }}>Riprova</button>
            )}
        </div>
    );
}
